import React, { useEffect, useState } from 'react';
import { Inputs, SwitchComponent } from '../../../../../../Components';
import FieldWithLabel from '../../../../../../Components/FieldWithLabel/FieldWithLabel';
import { GetAllLeadExchangePoolConfiguration } from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { showError } from '../../../../../../Helper';

export default function GlobalSystemBehaviours({
  translate,
  parentTranslationPath,
  setSystemBehaviours,
  systemBehaviours,
  isSubmitted,
  setIsSubmitted,
}) {
  const getAllLeadExchangePoolConfiguration = async () => {
    try {
      const result = await GetAllLeadExchangePoolConfiguration();
      setSystemBehaviours(result);
    } catch {
      showError('Failed to fetch global system behaviours.');
    }
  };

  useEffect(() => {
    getAllLeadExchangePoolConfiguration();
  }, []);
  return (
    <>
      <div className='global-system-behaviours'>
        <span className='global-system-title'>
          {translate('choose_config')}
        </span>
        <div className='global-system-fields'>
          <SwitchComponent
            idRef='ReturnRef'
            themeClass='thick-theme'
            labelValue={'return_closed_leads_to_pools'}
            parentTranslationPath={parentTranslationPath}
            isChecked={systemBehaviours.isReturnClosedLeadsToPool}
            onChangeHandler={(_, isChecked) => {
              setSystemBehaviours({
                ...systemBehaviours,
                isReturnClosedLeadsToPool: isChecked,
              });
            }}
          />
          <SwitchComponent
            idRef='reclaimRef'
            themeClass='thick-theme'
            labelValue={'allow_reclaim_by_previous_agent'}
            parentTranslationPath={parentTranslationPath}
            isChecked={systemBehaviours.isAllowReclaimByPreviousAgent}
            onChangeHandler={(_, isChecked) => {
              setSystemBehaviours({
                ...systemBehaviours,
                isAllowReclaimByPreviousAgent: isChecked,
              });
            }}
          />
          <SwitchComponent
            idRef='claimRef'
            themeClass='thick-theme'
            labelValue={'allow_claim_multiple_leads_per_contact'}
            parentTranslationPath={parentTranslationPath}
            isChecked={systemBehaviours.isAllowMultipleClaimsPerContact}
            onChangeHandler={(_, isChecked) => {
              setSystemBehaviours({
                ...systemBehaviours,
                isAllowMultipleClaimsPerContact: isChecked,
                maxClaimsPerContactPerAgent: null,
              });
              setIsSubmitted(false);
            }}
          />
        </div>
      </div>
      <span className='field_divider'></span>
      {systemBehaviours.isAllowMultipleClaimsPerContact && (
        <FieldWithLabel
          hideDivider
          label={translate('max_claim')}
          component={
            <Inputs
              wrapperClasses='w-50'
              idRef='maxClaimRef'
              inputPlaceholder={'0'}
              fieldClasses='fields-content'
              type={'number'}
              parentTranslationPath={parentTranslationPath}
              value={systemBehaviours.maxClaimsPerContactPerAgent}
              onInputChanged={(event) => {
                const { value } = event.target;
                setSystemBehaviours({
                  ...systemBehaviours,
                  maxClaimsPerContactPerAgent: +value,
                });
              }}
              isWithError
              error={systemBehaviours.maxClaimsPerContactPerAgent <= 0}
              helperText={
                systemBehaviours.maxClaimsPerContactPerAgent <= 0
                  ? 'Please specify max claims allowed per contact'
                  : ''
              }
              isSubmitted={isSubmitted}
            />
          }
        />
      )}
    </>
  );
}
